<script setup lang="ts">
import { useRealmSettings } from '@/stores/useRealmSettings'
import {
  customElementPropsKey,
  type SocialProvider,
} from '@/types/customElementProps.types'
import { storeToRefs } from 'pinia'
import Cookies from 'universal-cookie'
import { inject, onMounted } from 'vue'

const templateProps = inject(customElementPropsKey)

const cookies = new Cookies(null, { path: new URL(document.baseURI).pathname })
const { realmSettings } = storeToRefs(useRealmSettings())

onMounted(() => {
  const preferredSocialProvider = cookies.get('starmind_kc_idp_preferred')
  if (
    preferredSocialProvider &&
    !cookies.get('starmind_kc_idp_infinite_loop_protection')
  ) {
    const loginUrl = templateProps?.supportedSocialProviders?.find(
      ({ alias }) => alias === preferredSocialProvider,
    )?.loginUrl
    if (loginUrl) {
      setInfiniteLoopProtectionCookie()

      // let some time to set the cookie before redirection
      setTimeout(() => {
        window.location.href = loginUrl
      })
    }
  }
})

function setCookieAndRedirect(provider: SocialProvider) {
  if (!realmSettings.value?.auth.password_auth_enabled) {
    cookies.set('starmind_kc_idp_preferred', provider.alias, {
      maxAge: 30 * 24 * 60 * 60,
    })
    setInfiniteLoopProtectionCookie()
  }

  // let some time to set the cookie before redirection
  setTimeout(() => {
    window.location.href = provider.loginUrl
  })
}

function setInfiniteLoopProtectionCookie() {
  cookies.set('starmind_kc_idp_infinite_loop_protection', 1, { maxAge: 30 })
}
</script>

<template>
  <div class="mb-6 d-flex flex-column gap-4">
    <v-btn
      block
      class="min-height"
      v-for="provider in templateProps!.supportedSocialProviders"
      :key="provider.providerId"
      @click="setCookieAndRedirect(provider)"
    >
      {{
        $t('vue.authentication.login.saml', { provider: provider.displayName })
      }}
    </v-btn>
  </div>
</template>
<style lang="css" scoped>
.min-height {
  min-height: min-content !important;
}
::v-deep .v-btn__content{
  white-space: unset !important;
}
</style>
